// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__7VTq3","errorLogs":"EditorFooter_errorLogs__2J3KV"};